import { Divider, Grid } from '@mui/material';
import PropTypes from 'prop-types';
import { useState } from 'react';
import FormAutocomplete from './FormAutocomplete';
import FormDatePickerField from './FormDatePickerField';
import FormDEAField from './FormDEANumber';
import FormEinField from './FormEinField';
import FormEINWithFileDrop from './FormEINWithFileDrop';
import FormEmailDomainField from './FormEmailDomainField';
import FormFileDrop from './FormFileDrop';
import FormMedicareWithFileDrop from './FormMedicareWithFileDrop';
import FormMoneyField from './FormMoneyField';
import FormNPIField from './FormNPINumber';
import FormNPIWithFileDrop from './FormNPIWithFileDrop';
import FormPhoneNumberField from './FormPhoneNumField';
import FormRoutingNumber from './FormRoutingNumber';
import FormTextAreaField from './FormTextAreaField';
import FormTextField from './FormTextField';
import FormTextWithFileDrop from './FormTextWithFileDrop';
import FormToggleField from './FormToggleField';
import FormStaffInfoField from './StaffInfoField/FormStaffInfoField';
import FormStaffInfoFieldWithAddMore from './StaffInfoField/FormStaffInfoFieldWithAddMore';
import FormStaffInfoFieldWithButtons from './StaffInfoField/FormStaffInfoFieldWithButtons';
import FormStaffInfoFieldWithContracted from './StaffInfoField/FormStaffInfoFieldWithContracted';
import FormStaffInfoFieldWithDiffDept from './StaffInfoField/FormStaffInfoFieldWithDiffDept';

FormField.propTypes = {
  fieldName: PropTypes.string,
  fieldAttributes: PropTypes.object,
};

export default function FormField({ fieldName, fieldAttributes }) {
  const [focusedField, setFocusedField] = useState(null);

  return (
    <Grid
      item
      sx={{ pt: '0 !important' }}
      xs={12}
      sm={fieldAttributes.columns < 12 ? 6 : 12}
      lg={fieldAttributes.columns || 12}
      key={fieldName}
    >
      {fieldAttributes.fieldType === 'text' || fieldAttributes.fieldType === 'number' ? (
        <FormTextField
          fieldName={fieldName}
          fieldAttributes={fieldAttributes}
          focusedField={focusedField}
          setFocusedField={setFocusedField}
        />
      ) : fieldAttributes.fieldType === 'autocomplete' ? (
        <FormAutocomplete
          fieldName={fieldName}
          fieldAttributes={fieldAttributes}
          options={fieldAttributes.options || []}
        />
      ) : fieldAttributes.fieldType === 'phoneNumber' ? (
        <FormPhoneNumberField
          fieldName={fieldName}
          focusedField={focusedField}
          setFocusedField={setFocusedField}
          fieldAttributes={fieldAttributes}
        />
      ) : fieldAttributes.fieldType === 'ein' ? (
        <FormEinField
          fieldName={fieldName}
          focusedField={focusedField}
          setFocusedField={setFocusedField}
          fieldAttributes={fieldAttributes}
        />
      ) : fieldAttributes.fieldType === 'routingNumber' ? (
        <FormRoutingNumber
          fieldName={fieldName}
          fieldAttributes={fieldAttributes}
          focusedField={focusedField}
          setFocusedField={setFocusedField}
        />
      ) : fieldAttributes.fieldType === 'file' ? (
        <FormFileDrop fieldName={fieldName} fieldAttributes={fieldAttributes} />
      ) : fieldAttributes.fieldType === 'lineBreak' ? (
        <Divider sx={{ mb: 1, mt: 2, borderWidth: 1 }} />
      ) : fieldAttributes.fieldType === 'NPINumber' ? (
        <FormNPIField
          fieldName={fieldName}
          fieldAttributes={fieldAttributes}
          focusedField={focusedField}
          setFocusedField={setFocusedField}
        />
      ) : fieldAttributes.fieldType === 'DEANumber' ? (
        <FormDEAField
          fieldName={fieldName}
          fieldAttributes={fieldAttributes}
          focusedField={focusedField}
          setFocusedField={setFocusedField}
        />
      ) : fieldAttributes.fieldType === 'toggle' ? (
        <FormToggleField fieldName={fieldName} fieldAttributes={fieldAttributes} />
      ) : fieldAttributes.fieldType === 'emailDomain' ? (
        <FormEmailDomainField
          fieldName={fieldName}
          fieldAttributes={fieldAttributes}
          focusedField={focusedField}
          setFocusedField={setFocusedField}
        />
      ) : fieldAttributes.fieldType === 'date' ? (
        <FormDatePickerField
          fieldName={fieldName}
          fieldAttributes={fieldAttributes}
          focusedField={focusedField}
          setFocusedField={setFocusedField}
        />
      ) : fieldAttributes.fieldType === 'textArea' ? (
        <FormTextAreaField
          fieldName={fieldName}
          focusedField={focusedField}
          setFocusedField={setFocusedField}
          fieldAttributes={fieldAttributes}
        />
      ) : fieldAttributes.fieldType === 'money' ? (
        <FormMoneyField
          fieldName={fieldName}
          fieldAttributes={fieldAttributes}
          focusedField={focusedField}
          setFocusedField={setFocusedField}
        />
      ) : fieldAttributes.fieldType === 'EINWithFileDrop' ? (
        <FormEINWithFileDrop
          fieldName={fieldName}
          fieldAttributes={fieldAttributes}
          focusedField={focusedField}
          setFocusedField={setFocusedField}
        />
      ) : fieldAttributes.fieldType === 'NPIWithFileDrop' ? (
        <FormNPIWithFileDrop
          fieldName={fieldName}
          fieldAttributes={fieldAttributes}
          focusedField={focusedField}
          setFocusedField={setFocusedField}
        />
      ) : fieldAttributes.fieldType === 'TextWithFileDrop' ? (
        <FormTextWithFileDrop
          fieldName={fieldName}
          fieldAttributes={fieldAttributes}
          focusedField={focusedField}
          setFocusedField={setFocusedField}
        />
      ) : fieldAttributes.fieldType === 'MedicareWithFileDrop' ? (
        <FormMedicareWithFileDrop
          fieldName={fieldName}
          fieldAttributes={fieldAttributes}
          focusedField={focusedField}
          setFocusedField={setFocusedField}
        />
      ) : fieldAttributes.fieldType === 'staffInfo' ? (
        <FormStaffInfoField
          fieldName={fieldName}
          fieldAttributes={fieldAttributes}
          focusedField={focusedField}
          setFocusedField={setFocusedField}
        />
      ) : fieldAttributes.fieldType === 'staffInfoWithContracted' ? (
        <FormStaffInfoFieldWithContracted
          fieldName={fieldName}
          fieldAttributes={fieldAttributes}
          focusedField={focusedField}
          setFocusedField={setFocusedField}
        />
      ) : fieldAttributes.fieldType === 'staffInfoWithDiffDept' ? (
        <FormStaffInfoFieldWithDiffDept
          fieldName={fieldName}
          fieldAttributes={fieldAttributes}
          focusedField={focusedField}
          setFocusedField={setFocusedField}
        />
      ) : fieldAttributes.fieldType === 'staffInfoAddMore' ? (
        <FormStaffInfoFieldWithAddMore
          fieldName={fieldName}
          fieldAttributes={fieldAttributes}
          focusedField={focusedField}
          setFocusedField={setFocusedField}
        />
      ) : fieldAttributes.fieldType === 'staffInfoButtons' ? (
        <FormStaffInfoFieldWithButtons
          fieldName={fieldName}
          fieldAttributes={fieldAttributes}
          focusedField={focusedField}
          setFocusedField={setFocusedField}
        />
      ) : null}
    </Grid>
  );
}
